import { Mutation, gql } from 'apollo-angular';


import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UpdateUnitPreferences extends Mutation<any> {
  document = gql`
      mutation setPreferences($preferences: PreferencesInput!) {
          setPreferences(preferences: $preferences) {
            unitFormatPreferences  {
                  active {
                      label
                      value
                  }
                  options {
                      label
                      value
                  }
              }
          }
      }
  `;
}
